import { useEffect, useState } from "react";
import "../styles/faq-page.css";
export default function FAQPage() {
  const [faqs, setFaqs] = useState([]);

  useEffect(() => {
    document.title = "amantes30 | FAQ";

    const navIcons = document.querySelectorAll(".icon-wrapper");
    navIcons.forEach((icon) => {
      icon.classList.remove("active");
    });
    const selectedIcon = document.getElementById("FAQ-icon");
    if (selectedIcon) {
      selectedIcon.classList.add("active");
    }

    async function fetchData() {
      document.getElementById("load-icon-wrapper").classList.toggle("on", true);

      await fetch(`${process.env.REACT_APP_API_URL}/faq`, {
        method: "GET",
      })
        .then((res) => res.json())
        .then((data) => {
          document
            .getElementById("load-icon-wrapper")
            .classList.toggle("on", false);

          setFaqs(data.results);
        })
        .catch((error) => {
          console.error("Error fetching FAQs:", error);
        });
    }
    fetchData();
  }, []);
  return (
    <div className="faq-page">
      <section className="hero">
        <h1 className="hero-text">Frequently Asked Questions</h1>
        <p className="hero-desc">
          Welcome to the FAQ Page. Here you can find answers to the most common
          questions about my services and company.
        </p>
      </section>
      <section className="faq-list">
        <h2 className="gc-text">General Questions</h2>

        {faqs.map((faq, idx) => (
          <div className="faq-item" key={idx}>
            <h3>
              <img src="/images/68.png" alt="icon" className="arrow" />
              {faq.question}
            </h3>
            <p>{faq.answer}</p>
          </div>
        ))}
      </section>
    </div>
  );
}
